module.exports = __webpack_public_path__ + "img/general-bg-2.c2bc9f07.svg";